<svelte:window on:beforeunload={onBeforeUnload} />

{#each plan.fields as field, i}
    {#if fieldDetails[i].visible}
        <div class="plan-page__field {fieldDetails[i].class}">
            <div class="plan-page__field-title">
                <span class="plan-page__property-label" id={fieldDetails[i].labelId}>
                    {fieldDetails[i].label}
                </span>
                {#if field.type === plannerFieldType.RichText || field.type === plannerFieldType.PlanDescription}
                    <div class="plan-page__field-actions">
                        {#if (plan.description || plan.title) && field.type === plannerFieldType.PlanDescription && window.plansConfig.isImmersiveReaderEnabled && !config.childId && !config.publicAccessKey}
                            <IconButton
                                text={i18n.listen}
                                ariaLabel={formatLanguageString(
                                    i18n.listenTo,
                                    fieldDetails[i].label
                                )}
                                iconClass="plan-page_listen-description-icon"
                                type="plain"
                                htmlType="button"
                                on:click={async () => await listen(plan)}
                            />
                        {/if}
                        {#if config.canEdit}
                            <IconButton
                                text={i18n.editRichText}
                                iconClass="plan-page_edit-description-icon"
                                type="plain"
                                htmlType="button"
                                on:click={() => editDescription(i)}
                            />
                        {/if}
                    </div>
                {/if}
                {#if !config.canEdit && config.isLearner}
                    {#if isPlanCompleted
                        && field.type !== plannerFieldType.PlanDescription
                        && field.type !== plannerFieldType.LearningObjectives}
                        <PlanCompleted />
                    {:else if field.type === plannerFieldType.Resources && plan.elements.filter(e => e.isResource && !e.isFolder).length > 0}
                        <ProgressSection
                            showTag={false}
                            planHasCompletedTasks={plan.elements.some(
                                e => e.isResource && e.isCompleted && !e.isFolder
                            )}
                            planUrl={plan.url}
                            taskType={plannerFieldType.Resources}
                            nextTask={plan.elements
                                .filter(e => e.isResource && !e.isFolder)
                                .find(e => !e.isCompleted)}
                            currentTaskNo={plan.elements.filter(
                                e => e.isResource && e.isCompleted && !e.isFolder
                            ).length}
                            totalTaskNo={plan.elements.filter(e => e.isResource && !e.isFolder)
                                .length}
                            fieldType={plannerFieldType.Resources}
                            {backExtraParams}
                        />
                    {:else if field.type === plannerFieldType.Activities}
                        <ProgressSection
                            showTag={false}
                            planHasCompletedTasks={plan.elements.some(
                                e => !e.isResource && e.isCompleted
                            )}
                            planUrl={plan.url}
                            taskType={plannerFieldType.Activities}
                            nextTask={plan.elements
                                .filter(e => !e.isResource)
                                .find(e => !e.isCompleted)}
                            currentTaskNo={plan.elements.filter(e => !e.isResource && e.isCompleted)
                                .length}
                            totalTaskNo={plan.elements.filter(e => !e.isResource).length}
                            fieldType={plannerFieldType.Activities}
                            {backExtraParams}
                        />
                    {:else if field.type === plannerFieldType.Elements && plan.elements.filter(e => !e.isFolder).length > 0}
                        <ProgressSection
                            showTag={false}
                            planHasCompletedTasks={plan.elements.some(e => e.isCompleted)}
                            planUrl={plan.url}
                            taskType={plannerFieldType.Elements}
                            nextTask={plan.elements.find(e => !e.isCompleted)}
                            currentTaskNo={plan.elements.filter(e => e.isCompleted && !e.isFolder)
                                .length}
                            totalTaskNo={plan.elements.filter(e => !e.isFolder).length}
                            fieldType={plannerFieldType.Elements}
                            {backExtraParams}
                        />
                    {/if}
                {/if}
            </div>
            {#if field.type === plannerFieldType.RichText}
                <RichText
                    bind:this={richTextEdits[i]}
                    bind:value={field.text}
                    displayValue={field.displayText}
                    showTextArea={field.isPlainText}
                    {i18n}
                    {config}
                    labelledBy={fieldDetails[i].labelId}
                    title={fieldDetails[i].label}
                    placeholder={i18n.addText}
                    hideEditButton={true}
                    safeHtmlProvider={html => updateCustomPlanField(plan.id, field.columnId, html)}
                />
            {:else if field.type === plannerFieldType.PlanDescription}
                <RichText
                    bind:this={richTextEdits[i]}
                    bind:value={plan.description}
                    displayValue={plan.displayDescription}
                    showTextArea={plan.isDescriptionPlainText}
                    {i18n}
                    {config}
                    placeholder={config.canEdit
                        ? i18n.noDescription_SinglePlan_Teacher
                        : i18n.noDescription_SinglePlan_Student}
                    labelledBy={fieldDetails[i].labelId}
                    title={fieldDetails[i].label}
                    safeHtmlProvider={html => updatePlanDescription(plan.id, html)}
                    hideEditButton={true}
                />
            {:else if field.type === plannerFieldType.LearningObjectives}
                {#if plan.learningObjectives.length}
                    <div class="plan-page__learning-objectives-list">
                        {#each plan.learningObjectives as lo (lo.id)}
                            <LearningObjective
                                id={lo.id}
                                title={lo.title}
                                description={lo.description}
                                isTooltipDialogOpened={showTooltipDialog}
                                on:openTooltipDialog={openTooltipDialog}
                                on:closeTooltipDialog={closeTooltipDialog}
                            />
                        {/each}
                    </div>
                    <div class="plan-page__learning-objective__tooltipdialog-container">
                        <TooltipDialog
                            show={showTooltipDialog}
                            element={learningObjectiveElement}
                            placement={tooltipDialogPlacement}
                            idLO={idLearningObjective}
                            heading={headingTooltipDialog}
                            text={textTooltipDialog}
                            closeButtonText={i18n.close}
                            showActions={config.canEdit}
                            linkText={i18n.goToProgressReport}
                            actionButtonText={i18n.remove}
                            actionButtonLabel={i18n.removeFromPlan}
                            courseId={config.courseId}
                            on:delete={removeLearningObjectiveFromPlan(idLearningObjective)}
                            on:close={closeTooltipDialog}
                        />
                    </div>
                {/if}
                {#if config.canEdit}
                    <div aria-live="assertive" class="plan-page__property-error-text plan-page__learning-objectives-error">
                        {loError}
                    </div>
                    <IconButton
                        type="plain"
                        htmlType="button"
                        iconClass="plan-edit-description-icon add-lo-button"
                        text={i18n.addLearningObjectives}
                        on:click={showAddLOModal}
                        disabled={losDirty}
                        loading={losDirty}
                    />
                    <LearningObjectivePicker
                        bind:enabled={loPickerEnabled}
                        {rootLearningObjective}
                        initialLearningObjectives={plan.learningObjectives}
                        getLearningObjectives={loadLearningObjectives}
                        initialSelectionDisabled={true}
                        {i18n}
                        on:apply={e => applyNewLearningObjectives(e.detail)}
                    />
                {/if}
            {:else if field.type === plannerFieldType.Resources}
                <ElementList
                    labelledBy={fieldDetails[i].labelId}
                    bind:elements={plan.elements}
                    bind:orderDirty={fieldDetails[i].isDirty}
                    elementsFilter={e => e.isResource}
                    {field}
                    {plan}
                    {isParent}
                    {numberOfPlansInCourse}
                    elementsUrlExtraParams={backExtraParams}
                />
                {#if config.canEdit}
                    <AddResourcesMenu
                        text={i18n.addResourceButtonText}
                        useGenericResourceColumn={config.useGenericResourceColumn}
                        isResource={true}
                        courseConfig={config}
                        {plan}
                        {i18n}
                        initialResources={planElementsResourcesOnly}
                        planFilesStatusStore={planFilesStatus}
                        availabilityOfTemplateTypes={config.availableTemplateTypes}
                        on:resourceAdded={handleResourceAdded}
                    />
                {/if}
            {:else if field.type === plannerFieldType.Activities}
                <ElementList
                    labelledBy={fieldDetails[i].labelId}
                    bind:elements={plan.elements}
                    bind:orderDirty={fieldDetails[i].isDirty}
                    elementsFilter={e => !e.isResource}
                    {field}
                    {plan}
                    {isParent}
                    {numberOfPlansInCourse}
                    elementsUrlExtraParams={backExtraParams}
                />
                {#if config.canEdit}
                    <AddResourcesMenu
                        text={i18n.addActivityButtonText}
                        useGenericResourceColumn={config.useGenericResourceColumn}
                        isResource={false}
                        courseConfig={config}
                        {plan}
                        {i18n}
                        initialResources={planElementsActivitiesOnly}
                        planFilesStatusStore={planFilesStatus}
                        availabilityOfTemplateTypes={config.availableTemplateTypes}
                        on:resourceAdded={handleResourceAdded}
                    />
                {/if}
            {:else if field.type === plannerFieldType.Elements}
                <ElementList
                    labelledBy={fieldDetails[i].labelId}
                    bind:elements={plan.elements}
                    bind:orderDirty={fieldDetails[i].isDirty}
                    {field}
                    {plan}
                    {isParent}
                    {numberOfPlansInCourse}
                    elementsUrlExtraParams={backExtraParams}
                />
                {#if config.canEdit}
                    <AddResourcesMenu
                        text={i18n.addButtonText}
                        useGenericResourceColumn={config.useGenericResourceColumn}
                        courseConfig={config}
                        {plan}
                        {i18n}
                        initialResources={plan.elements}
                        planFilesStatusStore={planFilesStatus}
                        availabilityOfTemplateTypes={config.availableTemplateTypes}
                        on:resourceAdded={handleResourceAdded}
                    />
                {/if}
            {/if}
        </div>
    {/if}
{/each}

<script>
    import { onMount } from "svelte";
    import { plannerFieldType, plannerFieldTypeReversed } from "@its-ui/planner-common/constants";
    import { getJson } from "@itslearning/atlas/network/fetchJson";
    import {
        updatePlanDescription,
        updateCustomPlanField
    } from "@its-ui/planner-common/controllers/updatePlanController";
    import { formatLanguageString } from "@itslearning/atlas/strings/format";
    import {
        loadLearningObjectives,
        updateLearningObjectives,
        removeLearningObjective
    } from "@its-ui/planner-common/controllers/learningObjectivesController";

    import LearningObjectivePicker from "@itslearning/prometheus/assets/modals/LearningObjectivePicker/v1/LearningObjectivePicker.svelte";
    import IconButton from "@itslearning/prometheus/assets/inputs/IconButton/v1/IconButton.svelte";

    import RichText from "@its-ui/planner-common/components/RichText/RichText.svelte";
    import AddResourcesMenu from "@its-ui/planner-common/components/AddResourcesMenu/AddResourcesMenu.svelte";
    import ElementList from "../ElementList/ElementList.svelte";
    import LearningObjective from "@its-ui/planner-common/components/LearningObjective/LearningObjective.svelte";
    import TooltipDialog from "@its-ui/planner-common/components/TooltipDialog/TooltipDialog.svelte";
    import PlanCompleted from "@its-ui/planner-common/components/PlanCompleted/PlanCompleted.svelte";
    import { isPlanCompletedHelper } from "@its-ui/planner-common/helpers/isPlanCompletedHelper";
    import ProgressSection from "../ProgressSection/ProgressSection.svelte";

    import { planData, planFilesStatus } from "@its-ui/planner-common/logic/planPage/stores";

    export let plan;
    export let config;
    export let i18n;
    export let isParent;
    export let numberOfPlansInCourse;
    export let backExtraParams = null;

    const richTextEdits = new Array(plan.fields.length).fill(undefined);

    let isPlanCompleted = false;
    let loError = "";
    let loPickerEnabled = false;
    let losDirty = false;
    let fieldDetails;

    // TooltipDialog vars
    let learningObjectiveElement = null;
    let showTooltipDialog = false;
    let idLearningObjective;
    let headingTooltipDialog;
    let textTooltipDialog;
    let tooltipDialogPlacement;

    onMount(async () => {
        if (window.loadIframelyEmbedJs) {
            window.loadIframelyEmbedJs();
        }

        isPlanCompleted = isPlanCompletedHelper(plan);
    });

    $: planElementsResourcesOnly =
        plan && plan.elements ? plan.elements.filter(e => e.isResource) : [];
    $: planElementsActivitiesOnly =
        plan && plan.elements ? plan.elements.filter(e => !e.isResource) : [];

    $: if (!fieldDetails && plan.fields) {
        fieldDetails = plan.fields.map(field => ({
            label: fieldName(field),
            labelId: `plan-field-${field.type}-${field.columnId}`,
            visible: fieldVisible(field),
            class: `plan-page__field-${plannerFieldTypeReversed[field.type].toLowerCase()}`,
            isDirty: false
        }));
    }

    $: rootLearningObjective = {
        id: 0,
        title: config.courseTitle,
        description: formatLanguageString(
            i18n.learningObjectivesConnectedToCourse,
            config.courseTitle
        )
    };

    // Fired when the window is being closed or the user is navigating away
    function onBeforeUnload(event) {
        // Check update handlers to see if any have unsaved changes
        if (unsavedChanges()) {
            // Prompt the user there may be unsaved changes
            event.preventDefault();
            event.returnValue = "";
        }
    }

    function unsavedChanges() {
        return (
            losDirty ||
            fieldDetails.some(f => f.updateHandler && f.updateHandler.isDirty) ||
            fieldDetails.some(f => f.isDirty)
        );
    }

    function fieldName(field) {
        if (field.headingText) {
            return field.headingText;
        }

        switch (field.type) {
            case plannerFieldType.PlanDescription:
                return i18n.descriptionHeader;
            case plannerFieldType.Resources:
                return i18n.resources_Header;
            case plannerFieldType.Activities:
                return i18n.activities_Header;
            case plannerFieldType.Elements:
                return i18n.resourcesAndActivitiesHeader;
            case plannerFieldType.LearningObjectives:
                return i18n.learningObjectivesHeader;
            default:
                return "";
        }
    }

    function fieldVisible(field) {
        switch (field.type) {
            case plannerFieldType.LearningObjectives:
                return (
                    config.hasCourseSettingLearningObjectives &&
                    (plan.learningObjectives.length || config.canEdit)
                );
            case plannerFieldType.Elements:
                return config.useGenericResourceColumn && (plan.elements.length || config.canEdit);
            case plannerFieldType.Resources:
                return (
                    !config.useGenericResourceColumn &&
                    (planElementsResourcesOnly.length || config.canEdit)
                );
            case plannerFieldType.Activities:
                return (
                    !config.useGenericResourceColumn &&
                    (planElementsActivitiesOnly.length || config.canEdit)
                );
            case plannerFieldType.RichText:
                return config.canEdit || (field.text && field.text.length);
            case plannerFieldType.PlanDescription:
                return true;
            default:
                return false;
        }
    }

    function showAddLOModal() {
        loPickerEnabled = true;
    }

    async function applyNewLearningObjectives(newLearningObjectives) {
        loError = "";
        losDirty = true;

        await updateLearningObjectives(
            plan.id,
            newLearningObjectives.map(lo => lo.id)
        )
        .then(() => {
            plan.learningObjectives = newLearningObjectives;
        })
        .catch(() => {
            loError = i18n.addLOError;
        })
        .finally(() => {
            losDirty = false;
        });
    }

    async function removeLearningObjectiveFromPlan(loId) {
        closeTooltipDialog();
        loError = "";
        losDirty = true;

        await removeLearningObjective(plan.id, loId);

        losDirty = false;

        plan.learningObjectives = plan.learningObjectives.filter(i => i.id !== loId);
    }

    // Open/close the tooltip dialog
    function openTooltipDialog({ detail }) {
        if (detail.learningObjectiveElement) {
            learningObjectiveElement = detail.learningObjectiveElement;
            idLearningObjective = detail.id;
            headingTooltipDialog = detail.heading;
            textTooltipDialog = detail.text;
            showTooltipDialog = true;
            tooltipDialogPlacement = detail.placement;
        }
    }

    function closeTooltipDialog() {
        showTooltipDialog = false;
    }

    const handleResourceAdded = ({ detail: { updatedPlan } }) =>
        ($planData.plan.elements = updatedPlan.elements);

    function editDescription(index) {
        richTextEdits[index].edit();
    }

    async function listen(plan) {
        const resourceType = "PlanDescription";
        const resourceId = plan.id;

        const response = await getJson(


            `/restapi/personal/immersivereader/v1?ResourceType=${resourceType}&ResourceId=${resourceId}`
        );

        const immersiveReaderData = {
            accessToken: response.AccessToken,
            subDomain: response.SubDomain,
            content: {
                title: response.Title,
                chunks: [
                    {
                        content: response.Text
                    }
                ]
            },
            options: {
                uiLang: response.UiLang,
                uiZIndex: 1000000
            }
        };

        window.ImmersiveReader.launchAsync(
            immersiveReaderData.accessToken,
            immersiveReaderData.subDomain,
            immersiveReaderData.content,
            immersiveReaderData.options
        );
    }
</script>
